import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteRole} from 'src/openapi/admin/apis/EntitlementsRoleApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    roleId: string,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveRole = ({roleId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((reason: string) => apiDispatch(
        deleteRole({roleId, deleteRoleRequest: {reason}}),
    ), [roleId, apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
